import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=201945de&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('201945de')) {
      api.createRecord('201945de', component.options)
    } else {
      api.reload('201945de', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=201945de&", function () {
      api.rerender('201945de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iKdNSyPAhn4t/JS/offershelp.vue"
export default component.exports